import React, { useEffect, useState, useRef } from 'react'
import Matter from 'matter-js';

import happyImage from '../../images/emoji/happy.svg';
import loveImage from '../../images/emoji/love.svg';
import neutralImage from '../../images/emoji/neutral.svg';
import sadImage from '../../images/emoji/sad.svg';
import thumbs_upImage from '../../images/emoji/thumbs_up.svg';

const EmojiDropping = ({ emoji, showUi }) => {

  const boxRef = useRef(null)

  const [constraints, setContraints] = useState()
  const [scene, setScene] = useState()
  const [dropShapes, setDropShapes] = useState(true)

  const handleResize = () => {
    setContraints(boxRef.current.getBoundingClientRect())
    // because setContraints is a react State,
    // the above line causes the dropShape interval to re-render,
    // releasing another set of balls.
    // After trying various things, settled on this solution:
    setDropShapes(false);
  }

  useEffect(() => {

    if (scene && emoji!='send') {
      var ab, balls = 0;
      var total_balls = 6;
      ab = setInterval(dropEmoji, 200);
    }

    function dropEmoji() {
      let { width, height } = constraints
      balls += 1;

      var c = Matter.Bodies.polygon(
        Math.random() * (width),
        -100,
        4,
        100
      );

      const minSizeOfEmoji = 0.5;
      const maxSizeOfEmoji = width * 0.004;
      let sizeOfThisEmoji = Math.random() * (maxSizeOfEmoji - minSizeOfEmoji + 1) + minSizeOfEmoji;

      c.render.sprite.xScale = sizeOfThisEmoji;
      c.render.sprite.yScale = sizeOfThisEmoji;

      //c.render.sprite.texture = `${emoji}Image`; // couldn't get this working
      // so resorting to a clumsy switch statement instead
      switch(emoji) {
        case 'happy':
          c.render.sprite.texture = happyImage; break;
        case 'love':
          c.render.sprite.texture = loveImage; break;
        case 'neutral':
          c.render.sprite.texture = neutralImage; break;
        case 'sad':
          c.render.sprite.texture = sadImage; break;
        default:
          c.render.sprite.texture = thumbs_upImage; break;
      }

      Matter.World.add(scene.engine.world, c);

      if (balls > total_balls) {
        clearInterval(ab);
      }
    }

  }, [emoji])

  useEffect(() => {
    setContraints(boxRef.current.getBoundingClientRect())
  }, [showUi]); // this prop gets updated as each new prompt appears
  // page may be taller than before, so we need to re-calculate the height
  // so that the emoji shapes drop to the (new) bottom of the screen

  useEffect(() => {
    let Engine = Matter.Engine
    let Render = Matter.Render
    let World = Matter.World
    let Bodies = Matter.Bodies

    let engine = Engine.create({})

    let render = Render.create({
      element: boxRef.current,
      engine: engine,
      //canvas: canvasRef.current,
      options: {
        background: 'transparent',
        wireframes: false,
      },
    })

    Matter.Runner.run(engine)
    Render.run(render)

    setContraints(boxRef.current.getBoundingClientRect())
    setScene(render)

    window.addEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (constraints) {
      let { width, height } = constraints

      // SR - height set above, is only the Window
      // in case the page scrolls, we need the full body height
      height = document.body.offsetHeight;

      // Dynamically update canvas and bounds
      scene.bounds.max.x = width
      scene.bounds.max.y = height
      scene.options.width = width
      scene.options.height = height
      scene.canvas.width = width
      scene.canvas.height = height

    }

  }, [scene, constraints])


  return (
    <div ref={boxRef} className="w-screen h-screen absolute top-0 left-0 pointer-events-none"></div>
  )
}

export default EmojiDropping;
